import { DialogServiceEvent, IDialogConfig, IServices } from "@netent/origin";
import { IPlayUIState } from "@netent/playui";
import { ListenerCreator } from "../../types";

const show = () => (config: IDialogConfig): IPlayUIState => {
  const { title, text: message, fatal, buttons = [] } = config;

  return {
    dialog: {
      enabled: true,
      options: {
        title,
        message,
        centerMessage: true,
        cover: fatal,
        buttons: buttons.map(({ text: label, primary, action: callback }) => ({
          primary,
          label,
          callback
        }))
      }
    }
  };
};

const hide = (services: IServices) => (): IPlayUIState => {
  let stateChange: IPlayUIState = {
    dialog: {
      enabled: false
    }
  };
  // check autoplay selected rounds after dialog closes to make sure that it's always in sync with Services, this needs to be revisit after refactoring of autoplay services.
  if (services.autoplay.isAvailable() && !services.autoplay.isActive()) {
    stateChange = {
      ...stateChange,
      autoplay: {
        rounds: {
          selected: services.autoplay.getRemaining() || null
        }
      }
    };
  }

  return stateChange;
};

export const listeners = new Map<DialogServiceEvent, ListenerCreator>([
  ["show", show],
  ["hide", hide]
]);
